
import Promotions from '@/graphql/queries/promotions/Promotions'

export default {
  async asyncData({ $content, $graphql, app: { i18n: { locale }, $seoMeta } }) {
    const page = await $content(locale, 'pages/promotions').fetch()
    $seoMeta.update($seoMeta.page(page.seo))

    const { data } = await $graphql.query({
      clientId: 'eshop',
      query: Promotions,
      variables: { order: 'sortOrder_ASC' }
    })

    return {
      promotions: data.nodes,
      page
    }
  }
}
